/* eslint-disable react/display-name */
import * as React from 'react';
import { CSSProperties, ReactNode, forwardRef } from 'react';

export interface ListProps {
  style?: CSSProperties;
  children?: ReactNode;
}

export const List = forwardRef<HTMLUListElement, ListProps>((props, ref) => {
  return <ul ref={ref} {...props} className="columns-sorter" />;
});

List.defaultProps = {
  style: {},
};
